<template>
<div class="rwZz">
  <div class="topss">
    <p>顾客姓名：</p>
    <el-input v-model="namess" style="width: 200px;margin-right: 20px;" placeholder="请输入内容"></el-input>
    <p>顾客电话：</p>
    <el-input v-model="tel" style="width: 200px;margin-right: 20px;" placeholder="请输入内容"></el-input>
    <el-button type="primary" size="small" @click="sslb">搜索</el-button>
    <el-button type="primary" @click="showzzd = true" size="small">创建任务</el-button>
  </div>

  <ul class="btsss">
    <li>序号</li>
    <li>姓名</li>
    <li>联系方式</li>
    <li>任务方案编号</li>
    <li>创建时间</li>
    <li>接收单位</li>
    <li>相关咨询</li>
    <li>方案类型</li>
    <li>状态</li>
    <li>电子病历</li>
    <li></li>
  </ul>
  <div class="nr-boxss">
    <ul class="nr-css" v-for="(item, idx) in list">
      <li>{{idx+1}}</li>
      <li>{{item.CustomerName}}</li>
      <li>{{item.CustomerTel}}</li>
      <li>{{item.ReferralId.slice(0,8)}}</li>
      <li>{{item.ReferralAddTime}}</li>
      <li>{{item.ReferralCompanyName}}</li>
      <li>{{item.ReferralChooseId.slice(0,8)}}</li>
      <li>{{item.TaskType}}</li>
      <li>{{item.TaskStatusName}}</li>
      <li><el-button size="mini" @click="opdzbl(item.ReferralChooseId)">电子病历</el-button></li>
      <li><el-button size="mini" @click="deles(item.ReferralId, item.TaskStatus)">取消</el-button></li>
    </ul>
  </div>

  <el-dialog
      title="创建任务方案"
      :visible.sync="showzzd"
      width="600px"
  >
    <div class="rwkp">
      <p class="p-b10">姓名：{{csobj.name}}</p>
      <p class="p-b10">联系方式：{{csobj.tel}}</p>
      <div class="xxdw">
        <p>选择单位：</p>
        <el-select style="margin-right: 20px;width: 278px;" @change="dwbh"  v-model="dwidx" filterable class="xza"  size="small" placeholder="请选择">
          <el-option
              v-for="item in shopList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="xxdw">
        <p>任务开始时间：</p>
        <el-date-picker
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            style="width: 250px;"
            v-model="postdata.rwsj"
            type="date"
            size="small">
        </el-date-picker>
      </div>
      <div class="xxdw">
        <p>任务类型：</p>
        <el-select style="margin-right: 20px;width: 278px;" v-model="postdata.rwlx" filterable class="xza"  size="small" placeholder="请选择">
          <el-option
              v-for="item in rwlx"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="xxdw">
        <p>任务内容：</p>
        <el-input
            style="width: 450px;"
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="postdata.rwnr">
        </el-input>
      </div>
      <div class="xxdw">
        <p style="width: 5em;">备注：</p>
        <el-input
            style="width: 450px;"
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="postdata.bz">
        </el-input>
      </div>
    </div>

    <el-button type="primary" @click="save">提交</el-button>
  </el-dialog>

  <el-dialog
      title="电子病历详情"
      :visible.sync="showdzbl"
      width="800px"
  >
    <DZBL :ids="csid" v-if="showdzbl"></DZBL>
  </el-dialog>
</div>
</template>

<script>
import {getShoop, addrw, getrwList, deleRw} from "./api";

export default {
  name: "rwZz",
  data() {
    return {
      list: [],
      showzzd: false,
      postdata: {
        dwid: '',
        rwsj: '',
        rwlx: '',
        rwnr: '',
        bz: '',
        gsid: '',
        jsshopid: ''
      },
      shopList: [],
      rwlx: [],
      csobj: {},
      shopAll: [],
      dwidx: '',
      showdzbl: false,
      csid: '',
      namess: '',
      tel: ''
    }
  },
  created() {
    this.getmd()
    this.rwlx = [
      {
        value: '康复',
        label: '康复',
      },
      {
        value: '训练',
        label: '训练',
      },
      {
        value: '商品',
        label: '商品',
      },
      {
        value: '其他',
        label: '其他',
      }
    ]
    if (this.$store.state.users.CsUser) {
      this.csobj = {
        name: this.$store.state.users.CsUser.CustomerName,
        tel: this.$store.state.users.CsUser.CustomerTel
      }
    }

    this.getrwlb()

  },
  methods: {
    getmd() {
      let ling = this.$loading({text: '加载中...'})
      getShoop()
          .then(res => {
            ling.close()
            let arr = []
            if (res.Result.CompanyInfos && res.Result.CompanyInfos.length) {
              let obj = res.Result.CompanyInfos
              for (let i = 0; i < obj.length; i++) {
                if (obj[i].CompanyInfos) {
                  for (let  k = 0; k < obj[i].CompanyInfos.length; k++) {
                    for (let h = 0; h < obj[i].CompanyInfos[k].ShopInfos.length; h++) {
                      arr.push(obj[i].CompanyInfos[k].ShopInfos[h])
                    }
                  }
                }else {
                  if (obj[i].ShopInfos.length) {
                    for (let p = 0; p < obj[i].ShopInfos.length; p++) {
                      arr.push(obj[i].ShopInfos[p])
                    }
                  }
                }
              }
            }

            if (res.Result.ShopInfos && res.Result.ShopInfos.length) {
              for (let i = 0; i < res.Result.ShopInfos.length; i++) {
                arr.push(res.Result.ShopInfos[i])
              }
            }

            this.shopAll = arr
            if (arr.length) {
              let abb = []
              for (let i = 0; i < arr.length; i++) {
                abb.push({
                  value: i,
                  label: arr[i].ShopName
                })
              }
              this.shopList = abb
            }
          })
    },
    save() {
      if (!this.$store.state.expertClinic.qmUrl) return this.$alert('请医生先在小程序上设置签名！', '提示')
      if (this.dwidx === '') return this.$alert('请选择单位！', '提示')
      if (!this.postdata.rwsj) return this.$alert('请选择任务开始时间！', '提示')
      if (this.postdata.rwlx === '') return this.$alert('请选择任务类型！', '提示')
      this.postdata.dwid = this.shopAll[this.dwidx].ShopId
      this.postdata.gsid = this.shopAll[this.dwidx].ShopCompanyId
      let ling = this.$loading({text: '提交中...'})
      addrw(this.postdata)
      .then(res => {
        ling.close()
        if (res.ReturnCode == 5000) {
          this.showzzd = false
          this.getrwlb()
          this.postdata = {
            dwid: '',
            rwsj: '',
            rwlx: '',
            rwnr: '',
            bz: '',
            gsid: ''
          }
        }
      })
    },
    getrwlb() {
      let ling = this.$loading({text: '加载中...'})
      getrwList(this.namess, this.tel)
      .then(res => {
        ling.close()
        if (res.Result && res.Result.length) {
          this.list = res.Result
        }
      })
    },
    opdzbl(id) {
      this.csid = id
      this.showdzbl = true
    },
    deles(id, zt) {
      if (zt == 2) return
      let ling = this.$loading({text: '取消中...'})
      deleRw(id)
      .then(res => {
        ling.close()
        this.$alert(res.displaymsg, '提示')
        .then(r => {
          this.showzzd = false
          this.getrwlb()
        })
      })
    },

    sslb() {
      this.getrwlb()
    },
    dwbh(e) {
      console.log(e, this.shopList[e])
    }
  },
  components: {
    DZBL: () => import('./DZBL')
  }
}
</script>

<style scoped lang="scss">

.topss {
  padding: 20px;
  display: flex;
  align-items: center;
}


.btsss {
  display: flex;
  justify-content: space-between;
  background: #444444;
  color: #FFFFFF;
  padding: 8px 0;
  li{
    width: calc(11.111% - 13px);
  }
  li:nth-child(1) {
    width: 60px;
  }
  li:nth-child(11) {
    width: 60px;
  }
}
.nr-boxss {
  height: calc(100vh - 240px);
  overflow-y: auto;
  .nr-css {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #c7c7c7;
    li{
      width: calc(11.111% - 13px);
      padding: 10px 0;
    }
    li:nth-child(1) {
      width: 60px;
    }
    li:nth-child(11) {
      width: 60px;
    }
  }
}

.rwkp {
  text-align: left;
  color: #0a0a0a;
  padding-bottom: 10px;
  .xxdw {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
  }
  .p-b10 {padding-bottom: 10px;}
}
</style>
